import { createSelector } from '@reduxjs/toolkit';
import { selectMap, selectPolygons } from 'app/containers/Map/slice/selectors';

import { RootState } from 'types';
import { initialState } from '.';

import 'leaflet-draw';
import * as L from 'leaflet';
import { getAreaWithUnits } from 'utils/helpers';

const selectSlice = (state: RootState) => state.field || initialState;

export const selectField = createSelector([selectSlice], state => state);

export const selectAllRoutesFilters = createSelector(
  [selectField],
  state => state.allRoutesFilters,
);

export const selectFieldNotes = createSelector(
  [selectField],
  state => state.fieldNotes,
);

export const selectFieldProperties = createSelector(
  [selectField],
  state => state.fieldProperties,
);

export const selectImportFieldsFromSeasonState = createSelector(
  [selectField],
  state => state.importFieldsFromSeason,
);

export const selectEditFieldData = createSelector([selectField], state => {
  const latlngs = state.editField.latlngs;

  let readableArea = '';

  if (latlngs) {
    const coords = (latlngs as any).flat(3);
    const area = L.GeometryUtil.geodesicArea(coords);

    readableArea = getAreaWithUnits(area);
  }
  return { ...state.editField, readableArea };
});

export const selectTempFieldsList = createSelector(
  [selectField],
  state => state.tempFieldsList,
);

export const selectShapeFileId = createSelector(
  [selectField],
  state => state.shapeFileId,
);

export const selectMappedTempFieldsList = createSelector(
  [selectTempFieldsList, selectMap],
  (tempFieldsList, mapState) =>
    tempFieldsList
      .map(field => {
        const isSelected = Boolean(
          mapState.uploadFields.selectedIds.find(id => id === field.id),
        );
        return { ...field, isSelected };
      })
      .sort((x, y) => {
        if (x.isSelected === y.isSelected) {
          return x.id < y.id ? -1 : x.id > y.id ? 1 : 0;
        } else if (x.isSelected) {
          return -1;
        }

        return 1;
      }),
);

export const selectFieldListDataFromMapPolygons = createSelector(
  [selectPolygons],
  polygons => {
    return polygons.map(polygon => ({
      fieldId: polygon.fieldParameters.fieldId,
      area: polygon.fieldParameters.area,
      name: polygon.fieldParameters.name,
    }));
  },
);

export const selectEditFormState = createSelector(
  [selectField],
  state => state.editForm,
);

export const selectDeleteFieldLoading = createSelector(
  [selectField],
  state => state.deleteFieldLoading,
);

export const selectDrawnPolygonsArr = createSelector([selectField], state => {
  return state.drawnFields.polygonsArr;
});

export const selectMappedDrawnFieldsList = createSelector(
  [selectDrawnPolygonsArr],
  (
    polygonsArr,
  ): {
    isSelected: boolean;
    id: string;
    area: number;
    readableArea: string;
  }[] =>
    polygonsArr.map(polygon => {
      const coords = [...polygon.latlngs].flat(3);
      const area = L.GeometryUtil.geodesicArea(coords);

      const readableArea = getAreaWithUnits(area);

      return { isSelected: true, area, readableArea, id: polygon.id };
    }),
);
